// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Y6Uo","requiredAsterisk":"Info_requiredAsterisk__20kX5"};